import { render, staticRenderFns } from "./CambiarComercial.vue?vue&type=template&id=4c3f5161&"
import script from "./CambiarComercial.vue?vue&type=script&lang=js&"
export * from "./CambiarComercial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports